import React from 'react';

const BlockQuote = ({ }) => {
    return (
        <blockquote>
            <p>
                We can easily manage if we will only take, each day, the burden appointed to it. But the load will be too heavy for us if we carry yesterday’s burden over again today, and then add the burden of the morrow before we are required to bear it.
                <br />
                <cite>Robert Calibo</cite>
            </p>
        </blockquote>
    )
}

export default BlockQuote;